import { IoMdClose } from "react-icons/io";
import { IoChatbubbleOutline, IoChatbubblesOutline } from "react-icons/io5";
import PageParrotLogo from "./PageParrotLogo.jsx";
import { LIMITS } from "../Limits.js";

export default function Header({ toggleOpen, config, clearTrigger }) {

    function getChosenIcon() {
        const { workspaceStyles } = config;
        switch(workspaceStyles?.iconSetting3?.iconSetting) {
            case "choose":
                switch(workspaceStyles?.iconSetting3?.selectedIcon) {
                    case "chat1":
                        return <IoChatbubbleOutline className="header-icon" />;
                    case "chat2":
                        return <IoChatbubblesOutline className="header-icon" />;
                    default:
                        return <PageParrotLogo className="header-icon" />; // default parrot icon
                }
            case "workspace":
                switch(config?.workspaceType) {
                    case 0:
                        return (config?.icon?.image_132) ? <img src={config.icon.image_132} alt="workspace" className="header-icon" /> : <PageParrotLogo className="header-icon" />;
                    case 1:
                        return config?.icon ? <img src={config.icon} alt="workspace" className="header-icon" /> : <PageParrotLogo className="header-icon" />;
                    case 2:
                        return config?.icon ? <img src={`https://cdn.discordapp.com/icons/${config?.workspace}/${config.icon}`} alt="workspace" className="header-icon" /> : <PageParrotLogo className="header-icon" />;
                    default:
                        return <PageParrotLogo className="header-icon" />; // default parrot icon
                }
            case "upload":
                return <img src={workspaceStyles.customIcon} alt="workspace" className="header-icon" />;
            case "off":
                return;
            default:
                return <PageParrotLogo className="header-icon" />; // default parrot icon
        }
    }

    return (
        <div className="header">
            {getChosenIcon()}
            <h4 className={`header-title ${config?.workspaceStyles?.iconSetting3?.iconSetting === 'off' ? 'icon-off' : ''}`}>{config.chatTitle.length > LIMITS.chatTitle ? "Error" : config.chatTitle}</h4>
            <button className="header-exit" onClick={() => {clearTrigger(); toggleOpen()}}><IoMdClose className="header-exit-icon" /></button>
        </div>
    )
}
